import { calendarViewOptionsRegionName } from './CalendarModule.locstring.json';
import { useCalendarModuleCommandingHotkeys } from '../utils/bindCalendarModuleCommandingHotKeys';
import { observer } from 'mobx-react-lite';
import { CalendarModuleCommandBar } from 'owa-calendar-commandbar';
import { getInRibbonMode } from 'owa-command-ribbon-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SaveViewDialog } from 'owa-save-calendar-view-dialog';
import SkipLinkRegionToFirstFocusableChild from 'owa-skip-link/lib/components/SkipLinkRegionToFirstFocusableChild';
import { useStrategy } from 'owa-strategies';
import * as React from 'react';

export default observer(function CalendarModuleCommanding() {
    const Ribbon: React.FC = useStrategy('ribbon');

    useCalendarModuleCommandingHotkeys();

    const commandingView = getInRibbonMode() ? <Ribbon /> : <CalendarModuleCommandBar />;

    return (
        <>
            <SkipLinkRegionToFirstFocusableChild
                role="navigation"
                regionNameResourceId={calendarViewOptionsRegionName}>
                {commandingView}
            </SkipLinkRegionToFirstFocusableChild>
            {isFeatureEnabled('cal-saveCalendarView') && <SaveViewDialog />}
        </>
    );
});
